import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';

// services
import { AuthService } from '@app/shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { AchievementsModalService } from '@app/profile/components/profile-overview/achievements/achievements-modal/achievements-modal.service';
import { ContentCardService } from './../../../shared/components/content/content-card/content-card.service';

// types
import { AuthUser } from '@app/account/account-api.model';
import { UserOutcomeDetail } from '@app/outcomes/outcomes-api.model';
import { ProfileService } from '@app/profile/services/profile.service';
import { ProfileCollectionItem } from '@app/profile/profile-api.model';

export interface Profile {
  id: number;
}

@Component({
  selector: 'dgx-user-outcome-tile-v2',
  templateUrl: './user-outcome-tile-v2.component.html',
  styleUrls: ['./user-outcome-tile-v2.component.scss'],
})
export class UserOutcomeTileV2
  extends SubscriberBaseDirective
  implements OnInit, AfterViewInit
{
  @Input() public userOutcome: ProfileCollectionItem<UserOutcomeDetail>;
  @Input() public owner: Profile;
  @Input() public isSelected: boolean;
  @Input() public showSelectOption: boolean;
  @Input() public hideMenu: boolean;
  @Input() public expandCard?: boolean;
  @Input() public tileIndex?: number;
  @Input() public lazyChunkIndex?: number;
  @Output()
  public clickedTitleEllipses: EventEmitter<number[]> = new EventEmitter<
    number[]
  >();

  @ViewChild('title') public title: ElementRef<HTMLElement>;

  public indexesOfCardsToExpand: number[] = [];
  public showEllipsis: boolean;
  public userOutcomeContent: UserOutcomeDetail;
  public i18n = this.translateService.instant([
    'Core_Accomplishment',
    'Core_Award',
    'Core_Certificate',
    'Core_Degree',
    'Core_Badge',
    'A11y_ExpandForTitle',
  ]);

  public titleTranslationMap = {
    Accomplishment: this.i18n.Core_Accomplishment,
    Award: this.i18n.Core_Award,
    Certificate: this.i18n.Core_Certificate,
    Degree: this.i18n.Core_Degree,
    Badge: this.i18n.Core_Badge,
  };

  public authUser: AuthUser;

  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    private achievementsModalService: AchievementsModalService,
    private profileService: ProfileService,
    private contentCardService: ContentCardService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  public get ownerIsViewing(): boolean {
    return this.profileService.ownerIsViewing;
  }

  public ngOnInit() {
    this.userOutcomeContent = this.userOutcome.content as UserOutcomeDetail;
    this.authUser = this.authService?.authUser;
  }

  public ngAfterViewInit(): void {
    this.showEllipsis =
      this.title.nativeElement.clientHeight <
      this.title.nativeElement.scrollHeight;
    this.cdr.detectChanges();
  }

  public showDetails(): void {
    const content = this.userOutcome.content as UserOutcomeDetail;
    const ownerIsViewing =
      this.authUser?.viewerProfile?.userProfileKey === this.owner.id;
    this.achievementsModalService
      .showAchievementModal(
        this.owner.id,
        content.userOutcomeId,
        ownerIsViewing,
        !!content.imageUrl
      )
      .pipe(this.takeUntilDestroyed())
      .subscribe();
  }

  public onEllipsisClick(titleElement) {
    let newIndexesOfCardsToExpand;
    [this.showEllipsis, newIndexesOfCardsToExpand] =
      this.contentCardService.expandCard(
        titleElement,
        this.title,
        this.tileIndex,
        this.lazyChunkIndex
      );
    this.clickedTitleEllipses.emit(newIndexesOfCardsToExpand);
  }
}
